module.exports = __webpack_public_path__ + "0ebcf8bba7d55e4158645d7a54b32b0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/exercises.png
// module id = 945
// module chunks = 0